import styled from 'styled-components';

export const StyledUl = styled.ul`
  list-style: disc;
  list-style-position: inside;

  &:not(:first-child) {
    margin-top: ${(p) => p.theme.space[3]};
  }
`;
